import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { APP_INSTALLATION_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

const AppInstallationService = ComposedComponent =>
  reduxFetch([
    {
      resource: APP_INSTALLATION_RESOURCE,
      method: 'get',
      request: (appId, installationId, t) => ({
        url: apiRoutes.appInstallationsDetail(appId, installationId),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getAppInstallationFailed'),
          },
        },
        clearValueOnRequest: true,
      }),
    },
  ])(ComposedComponent);

export default AppInstallationService;
